import { render, staticRenderFns } from "./AuthorizeForm.vue?vue&type=template&id=1235e83a&scoped=true"
import script from "./AuthorizeForm.vue?vue&type=script&lang=js"
export * from "./AuthorizeForm.vue?vue&type=script&lang=js"
import style0 from "./AuthorizeForm.vue?vue&type=style&index=0&id=1235e83a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1235e83a",
  null
  
)

export default component.exports